module.exports = __webpack_public_path__ + "img/logo.a12e9915.svg";